/** Money formatter for API costs (Controlling). Unlike `formatEUR` (whole
 * euros for salaries), costs are small — show 2 to 4 fraction digits so
 * sub-cent per-call amounts stay legible. Currency is dynamic (EUR/USD)
 * since it comes from the backend per object. */
export function formatCost(amount: number, currency = "EUR"): string {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 2,
    maximumFractionDigits: 4,
  }).format(amount);
}

/** Parse a decimal-string amount and format it. Empty / invalid → "—". */
export function formatCostString(amount: string, currency = "EUR"): string {
  if (amount.trim() === "") return "—";
  const n = Number(amount);
  return Number.isFinite(n) ? formatCost(n, currency) : "—";
}
